export default __webpack_public_path__ + "static/5-22b7436b20590ba014aa845ced150cc2.png";